module.exports = __webpack_public_path__ + "static/media/visit.d82979c6.svg";